import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getGamificationProfileAction } from '../../shared/actions/gamification.actions';
import { GamificationService } from '../../shared/gamification.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { OeAppService } from '../../shared/oe-app.service';
import { getLeaderboardStatusSelector } from '../../shared/reducers/gamification-selectors';
import { AppState } from '../../shared/reducers/index.tx';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { GamificationPersonBadgeDto } from '../../shared/types/GamificationPersonBadgeDto';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { LeaderboardStatusType } from '../../shared/types/leaderboard-status-type';
import { LevelProgressDto } from '../../shared/types/LevelProgressDto';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'lp2-progress-page',
  templateUrl: './progress-page.component.html',
  styleUrls: ['./progress-page.component.scss', './progress-page.scss'],
})
export class ProgressPageComponent implements OnInit, OnDestroy {
  levelProgress: LevelProgressDto;
  leagues: GamificationLeagueDto[];
  gamificationSettings$: Observable<GamificationSettingsDto>;
  leaderboardStatus: LeaderboardStatusType;

  personBadges$: Observable<GamificationPersonBadgeDto[]>;
  contactId = this.oeAppPersonService.getPersonData().contactId;
  destroy = new Subject<boolean>();
  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;
  indexUrl = '/learning/unit-index.html'
  certificateEnabled = this.oeAppPersonService.certificateEnabled;


  constructor(
    private levelProgressService: LevelProgressService,
    private gamificationService: GamificationService,
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.gamificationService.getLeagues().subscribe((data) => (this.leagues = data));

    this.store.dispatch(getGamificationProfileAction());

    this.personBadges$ = this.gamificationService.getPersonBadges(this.contactId);

    // Hide the title bar if gamification
    UtilsService.removeTitleMenu();

    this.gamificationService.startRefreshGamification();

    this.store
      .pipe(select(getLeaderboardStatusSelector), takeUntil(this.destroy))
      .subscribe((data: LeaderboardStatusType) => (this.leaderboardStatus = data));

    this.levelProgressService.levelProgress$
      .pipe(takeUntil(this.destroy))
      .subscribe((level) => (this.levelProgress = level));
    this.levelProgressService.updateLevelProgress();

    this.gamificationSettings$ = this.gamificationService.getSettings();
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();

    this.gamificationService.stopRefreshGamification();
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/progress-page/progress-page.component.ts